import { FC } from 'react';

import { avatarDefaultUrl } from '../../../constants/images';
import { useI18nContext } from '../../../hooks/contexts/i18n.context';
import { HolderProps } from '../../../types/cart';
import { maskDocument, maskValue } from '../../../utils/privacy';
import * as Styles from './styles.userNaming';

type UserNamingProps = {
  holder: HolderProps
  theresAHolderAndItsMe: boolean
  isAKidsTicket: boolean
};

const UserNaming:FC<UserNamingProps> = ({ holder, theresAHolderAndItsMe, isAKidsTicket }) => {
  const { translate } = useI18nContext();

  return (
    <Styles.WrapperNaming>
      <Styles.AvataiContainer>
        <Styles.AvatarUser
          src={holder.picture ? holder.picture : avatarDefaultUrl}
          alt=''
        />
      </Styles.AvataiContainer>
      <Styles.ContainerName>
        <Styles.Name>
          {holder.name}
          {theresAHolderAndItsMe && <Styles.Me>({translate(['INFORMATION', 'YOU'])})</Styles.Me>}
        </Styles.Name>
        <Styles.Email>
          {isAKidsTicket ? maskDocument(maskValue(String(holder.document))) : maskValue(holder.email)}
        </Styles.Email>
      </Styles.ContainerName>
    </Styles.WrapperNaming>
  );
};

export default UserNaming;
